var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.8453 7.00006L8.33346 12.4882C8.6589 12.8137 8.6589 13.3413 8.33346 13.6667V13.6667C8.00802 13.9922 7.48038 13.9922 7.15495 13.6667L0.488281 7.00006L7.15495 0.333397C7.48038 0.00795979 8.00802 0.0079592 8.33346 0.333396V0.333396C8.6589 0.658833 8.6589 1.18647 8.33346 1.51191L2.8453 7.00006Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferBack);
export default __webpack_public_path__ + "static/media/transferBack.c20aa4655ad16a6255219f712202e9f1.svg";
export { ForwardRef as ReactComponent };